import { render, staticRenderFns } from "./CatiComp.vue?vue&type=template&id=d5175c58&scoped=true"
import script from "./CatiComp.vue?vue&type=script&lang=js"
export * from "./CatiComp.vue?vue&type=script&lang=js"
import style0 from "./CatiComp.vue?vue&type=style&index=0&id=d5175c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5175c58",
  null
  
)

export default component.exports